// Creates an address string from a `location` object.
// Format: {Street}, {zipcode} {city}

export function createAddress(location) {
  let address = ''

  if (location && location.address) {
    address = location.address
  }

  if (location && (location.zipcode || location.city)) {
    if (location.zipcode && location.city) {
      address = `${address}${address.length > 0 ? ', ' : ''}${location.zipcode} ${
        location.city.name
      }`
    } else if (!location.zipcode && location.city) {
      address = `${address}${address.length > 0 ? ', ' : ''}${location.city.name}`
    } else if (location.zipcode && !location.city) {
      address = `${address}${address.length > 0 ? ', ' : ''}${location.zipcode}`
    }
  }

  return address
}
